import Card from '@eversports/react-components/primitives/Card'
import Flex from '@eversports/react-components/primitives/Flex'
import { makeStyles } from '@mui/styles'
import React from 'react'

import Invoice from '../../../typings/Invoice'
import Venue from '../../../typings/Venue'
import BookingDetailsImage from '../common/BookingDetailsImage'
import InvoiceDetailsContent from '../common/InvoiceDetailsContent'

interface Props {
  venue: Venue
  invoice: Invoice
}

const useStyles = makeStyles(() => ({
  invoiceInformation: {
    flex: '60%',
  },
}))

const DesktopInvoiceDetails: React.FC<React.PropsWithChildren<Props>> = ({ venue, invoice }) => {
  const classes = useStyles()

  return (
    <Card raised>
      <Flex justifyContent="space-between">
        <Flex flexDirection="column" verticalSpacing="dense" padding="wide" className={classes.invoiceInformation}>
          <InvoiceDetailsContent venue={venue} invoice={invoice} />
        </Flex>
        {venue.images && venue.images[0] && <BookingDetailsImage src={venue.images[0].large} />}
      </Flex>
    </Card>
  )
}

export default React.memo(DesktopInvoiceDetails)
